<template>
  <div>
    <v-dialog 
      fullscreen    
      hide-overlay
      transition="slide-full-modal-transition" 
      v-model="formOpened" content-class="j_modal" persistent>
      <v-card>
        <div class="modal__header full_title pd_left_3">
          <button class="hamberger_menu" type="button"  @click="onAction('cancel')">
            <v-icon>mdi-menu</v-icon>
          </button>
          <span>Tab (SVG Component) <span class="sub_title">{{ `${idxNum} ${subTitle}` }}</span></span>
        </div>

        <v-card-text class="modal__formControl dark_theme type1 properties8">
          <!-- <v-form v-model="valid" ref="form"> -->
            <v-container>

              <v-card-actions class="modal_toolbar">
                <div class="tool_menus">
                  <div>
                    <div 
                    data-modal-quickbtn="Inner" 
                    title="Inner"
                    :class="chartItem.ChartType == __C_.TYPE_CODE_SINGLE ? 'selected': ''"
                    @click="onChartType(__C_.TYPE_CODE_SINGLE)"
                    />
                  </div>
                </div>
              </v-card-actions>
              <div class="modal_dark_btn has_separated_tabs">
                <j-button
                  class="type01 sky  type_full "
                  :class="{ disabled: !resetable }"
                  :disabled="!resetable"
                  @click="onAction('save')"
                >Save</j-button>
                <j-button v-if="modeMod" class="type01 delete  type_full" @click="onAction('delete')">Delete</j-button>
                <div class="check_wrapper">
                  <v-checkbox v-model="update" :label="'Update'"/>
                  <v-checkbox :label="'Page Svg'" />
                  <v-checkbox :label="'Fixed'" />
                </div>
                <button class="help" @click="(e) => { helper=!helper }"></button>
              </div>
              <div class="modal__formControl_inside">
                <v-tabs v-model="stepper" class="wrap__modal_wfix">
                  <v-tab data-type="navigation" title="navigation"></v-tab>
                  <v-tab data-type="database" title="database"></v-tab>
                  <v-tab data-type="canvas" title="canvas"></v-tab>
                  <v-tab class="final_tab" data-type="text" title="text"></v-tab>
                  <div class="separated_tabs">
                    <v-tab class="start_tab" data-type="tabs" title="tabs"></v-tab>
                    <v-tab class="normal_tab" data-type="draw" title="draw"></v-tab>
                    <v-tab class="final_tab" data-type="url" title="url"><v-icon>mdi-link</v-icon></v-tab>
                  </div>

                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-navigation ref="general" @import-item="onImport" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-database ref="database" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-canvas />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-text />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-svglib-tab-tabs />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-svglib-tab-draw />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-url @import-chart="onImportChart" />
                  </v-tab-item>
                </v-tabs>
                
                <component
                  class="canvasAreaLine"
                  :is="chartComponentName"
                  :style="`--area-width: ${this.canvas.CanvasWidth + 1}px; --area-height: ${this.canvas.CanvasHeight + 1}px;`"

                  :ChartType="chartItem.ChartType"
                  :Canvas="canvas"
                  :Text="chartItem.Text"

                  :ModalDraw="tabAttrs.draw"
                  :ModalTaps="tabAttrs.tabs"

                  :DataItems="chartData"

                  @moved="onMoved"
                  @to-xml-string="onXmlString"
                />

                <div v-if="!isPreviewChart" id="j-chart-table">
                  <div style="display: inline-block;">
                    <j-data-grid
                      hide-actions
                      :headers="previewHeaders"
                      :items="previewItems"
                    >
                      <template #items="props">
                        <tr :active="props.selected">
                          <td>{{ props.item.title }}</td>
                          <td style="text-align: center;">{{ props.item.plan }}</td>
                          <td style="text-align: center;">{{ props.item.actual }}</td>
                        </tr>
                      </template>
                    </j-data-grid>
                  </div>
                </div>

                <div v-if="helper" id="j-chart-helper">
                  <img :src="helperUrl" />
                </div>

              </div>
            </v-container>
          <!-- </v-form> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <j-alert
      v-model="msgOpen"
      :type="msgInfo.type"
      :title="msgInfo.title"
      :title-description="msgInfo.titleDescription"
      :message="msgInfo.message"
      :button="msgInfo.button"
      :button-text="msgInfo.buttonText"
      @yes="yes()"
      @cancel="msgOpen = false"
    ></j-alert>
  </div>
</template>

<script>
import __C from '@/primitives/_constant_'
// import _ChartDataDefault from '@/primitives/_pageSvglibTabDefault'
import ChartModalMixin from "@/mixins/chart.modal.common"
import JSvgComponents from "@/components/JLibSvgCustomComponents"
import JChartTabProps from './SysenvSvglibTab'

export default {
  name: 'sysenv-chartlib-bar-delta-modal',
  mixins: [
    ChartModalMixin
  ],
  components: {
    ...JSvgComponents.Component,
    ...JChartTabProps
  },
  data: () => ({
    chartComponentName: '',

    compareOnoff: false,
    background: false,
    valuetab: false,
    units: false,
    previewHeaders: [
      { type: 'text', text: 'title', value: 'title', sortable: false },
      { type: 'text', text: 'plan', value: 'plan', sortable: false },
      { type: 'text', text: 'actual', value: 'actual', sortable: false },
    ],
    idxNum: '',
    subTitle: ''
  }),
  computed: {
    helperUrl() { return this.chartItem.ChartNo && this.helper ? require(`../../../assets/helpDoc/logo.png`) : '' },
    previewItems() { return this.chartData },
    tabAttrs() { return this.chartItem.TabAttrs || {} }
  },
  watch: {
    // for the default chart-type setting
    chartData: {
      handler(val) {
        if (!val || val.length === 0) return
        // if the chart-type is not selected yet, 
        // set the default chart-type with __C.CHART.TYPE_CODE_EMBOSSED.
        if (this.modeNew && !this.chartItem['ChartType']) this.onChartType(__C.CHART.TYPE_CODE_EMBOSSED)
      },
      deep: true
    },
    formOpened(val) {
      if (!val) return

      this.stepper = 0
      // every time came into the modal, either the mode new or edit,
      // whole the store's data should be initialized.
      this.setEmpty()

      if (this.modeNew) {
        this.setChartItem({
          ChartDb: 'Library',
          CatCode: __C.CHART.CAT_CODE_COMPLIB_SVG_TAB,
          ChartType: __C.CHART.TYPE_CODE_NORMAL,
          QApplied: 'J',
        })
        
        // this.setChartData(_ChartDataDefault.DataItems)

        this.$refs.general.setData(this.formMode)

      } else {
        this.getChart()
      }
    }
  },
  methods: {
    itemIdx(Idx, chartNo) {
      this.idxNum = `(${Idx} / ${chartNo})`
    },
    itemName(val) {
      this.subTitle = val
    },
    onChartType(typeName) {
      // this.setChartItem({ ChartType: typeName })
    },
    onImportChart() {
      this.chartComponentName = this.chartItem.UrlEntrance
      
      let defaultData = JSvgComponents.Data[this.chartItem.UrlDefaultData]
      // console.log(JSvgComponents.Data[this.chartItem.UrlDefaultData]);
      if(!defaultData || Object.keys(defaultData).length === 0) {
        console.error('[Build Custom Chart] No default data found.')
        return
      }

      this.setChartItem({
        ...defaultData.Canvas,

        TabAttrs: {
          draw: defaultData.ModalDraw,
          tabs: defaultData.ModalTaps,
        },
        Text: defaultData.Text,

        JsonString: JSON.stringify(defaultData.DataItems)
      })
      // Set DataItems, not ChartData
      this.setChartData(defaultData.DataItems)
    },

    // CRUD Process
    getChart(code=null) {
      return new Promise(resolve => {
        this.chartLibraryService.getChartCustom(code || this.keyValue, null, res => {
          this.setChartItem(res)
          // Set DataItems, not ChartData
          this.setChartData(
            this.chartItem.QResultSummary && this.chartItem.QResultSummary.length > 0 ?
            this.chartItem.QResultSummary : (
              this.chartItem.JsonString ?
              JSON.parse(this.chartItem.JsonString) :
              []
            )
          )
          this.chartComponentName = this.chartItem.UrlEntrance
          this.$refs.general.setData(this.formMode)

          this.itemIdx(res.Idx, res.ChartNo)
          this.itemName(res.Name)

          resolve(res)
        })
      })
    },
    putChart(reqItem, callback) {
      this.chartLibraryService.putChartCustom(reqItem, callback)
    },
    updChart(reqItem, callback) {
      this.chartLibraryService.updChartCustom(reqItem, callback)
    },
    delChart(chartNo, callback) {
      this.chartLibraryService.delChartCustom(chartNo, callback)
    },
  }
}
</script>
